module.exports = __webpack_public_path__ + "img/bg_function01_2_d.73e0e2a8.gif";